export const depotType = [
  { label: 'Công cộng', value: 'PUBLIC_CHARGE' },
  { label: 'Gia đình', value: 'HOME_CHARGE' },
  { label: 'Trạm sạc riêng', value: 'PRIVATE_CHARGING' },
  { label: 'Kinh doanh cá thể', value: 'HYBRID_CHARGING' }
];